import { memo, useCallback, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { CommonService } from 'dashboard-services/services';
import { DropdownService } from 'primary-components';

import getApiConfig from 'api/ApiConfig';
import properties from 'resources/constants/properties.json';

import KeyFilterBody from '../KeyFilterBody';

import { useQueryClient } from '@tanstack/react-query';

const EMPTY_OBJ = {};

const getGroupName = value => {
  if(value?.groupName) {
    return value.groupName
  }
  if(CommonService.isJson(value)) {
    const parsed = JSON.parse(value)
    return parsed?.groupName || undefined
  }
  return value;
}

const EMPTY_ARRAY = [];
const SymbolKey = ({
  dependsOnParam = EMPTY_OBJ,
  ref,
  ...props
}) => {
  const dispatch = useDispatch(),
        [keyQuery, setKeyQuery] = useState(),
        queryClient = useQueryClient(),
        getApiConfigLocal = useCallback(() => dispatch(getApiConfig()), [dispatch]),
        groupName = useMemo(() => getGroupName(dependsOnParam?.value || dependsOnParam?.defaultValue), [dependsOnParam]),
        { fetchNextPage: fetchMoreSymbolKeys, isFetching: isFetchingKeys, isFetchingNextPage: isFetchingNextPageKeys, data: keysFromApi = EMPTY_ARRAY } = DropdownService.useQuerySymbolKeys({
          queryClient,
          input: keyQuery,
          groupName,
          useEs: properties.useEsSymbolListing === "true",
          getApiConfig: getApiConfigLocal,
          metadata: true
        })

  return (
    <KeyFilterBody
        {...props}
        fetchMoreKeys={fetchMoreSymbolKeys}
        groupName={groupName}
        isFetchingKeys={isFetchingKeys}
        isFetchingNextPageKeys={isFetchingNextPageKeys}
        keysFromApi={keysFromApi}
        ref={ref}
        setKeyQuery={setKeyQuery}
    />
  )
}

SymbolKey.displayName = "SymbolKey"

SymbolKey.propTypes = {
  dependsOnParam: PropTypes.object,
}

export default memo(SymbolKey);
